export const OpenAddUserModal = (value) => {
  return { type: "OPEN_ADD_USER_MODAL", value: value };
};
export const CloseAddUserModal = () => {
  return { type: "CLOSE_ADD_USER_MODAL" };
};
